<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>Testimonials</h2>
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Testimonials</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="expertise-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 expertise-item">
                <div class="row">
                    <div class="col-sm-6 col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                        <a
                            >routerLink="/blog-details">
                            <div class="expertise-inner">
                                <i class="icofont-doctor-alt"></i>
                                <h3>Certified Doctors</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-6 col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                        <a
                            >routerLink="/blog-details">
                            <div class="expertise-inner">
                                <i class="icofont-stretcher"></i>
                                <h3>Emergency</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-6 col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                        <a
                            >routerLink="/blog-details">
                            <div class="expertise-inner">
                                <i class="icofont-network"></i>
                                <h3>Teachnology</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-6 col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                        <a
                            >routerLink="/blog-details">
                            <div class="expertise-inner">
                                <i class="icofont-ambulance-cross"></i>
                                <h3>Ambulance</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 expertise-item">
                <div class="expertise-right">
                    <img src="assets/img/home-one/home-bg6.jpg" alt="Expertise" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="testimonial-area ptb-100">
    <div class="container">
        <div class="testimonial-wrap">
            <h2>What our patients say</h2>

            <div class="testimonial-slider owl-theme owl-carousel">
                <div class="testimonial-item">
                    <img src="assets/img/home-three/7.png" alt="Testimonial" />
                    <h3>John Mic</h3>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam id labore vitae cupiditate
                        dolorum voluptates dicta delectus quibusdam excepturi, veniam deserunt magni ipsam mollitia
                        optio, quas quis rem non reprehenderit.
                    </p>
                </div>

                <div class="testimonial-item">
                    <img src="assets/img/home-three/8.png" alt="Testimonial" />
                    <h3>Adam Smith</h3>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam id labore vitae cupiditate
                        dolorum voluptates dicta delectus quibusdam excepturi, veniam deserunt magni ipsam mollitia
                        optio, quas quis rem non reprehenderit.
                    </p>
                </div>

                <div class="testimonial-item">
                    <img src="assets/img/home-three/9.png" alt="Testimonial" />
                    <h3>Jac Jacson</h3>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam id labore vitae cupiditate
                        dolorum voluptates dicta delectus quibusdam excepturi, veniam deserunt magni ipsam mollitia
                        optio, quas quis rem non reprehenderit.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="doctors-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Meet Our Doctors</h2>
        </div>

        <div class="row">
            <div class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="doctor-item">
                    <div class="doctor-top">
                        <img src="assets/img/home-one/doctor/1.jpg" alt="Doctor" />
                        <a routerLink="/appointment">Get Appointment</a>
                    </div>

                    <div class="doctor-bottom">
                        <h3><a routerLink="/doctor-details">Dr. Babatunde</a></h3>
                        <span>Neurosurgeon</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                <div class="doctor-item">
                    <div class="doctor-top">
                        <img src="assets/img/home-one/doctor/2.jpg" alt="Doctor" />
                        <a routerLink="/appointment">Get Appointment</a>
                    </div>

                    <div class="doctor-bottom">
                        <h3><a routerLink="/doctor-details">Dr. Addision Smith</a></h3>
                        <span>Neurosurgeon</span>
                    </div>
                </div>
            </div>

            <div
                class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4 wow animate__animated animate__fadeInUp"
                data-wow-delay=".7s"
            >
                <div class="doctor-item">
                    <div class="doctor-top">
                        <img src="assets/img/home-one/doctor/3.jpg" alt="Doctor" />
                        <a routerLink="/appointment">Get Appointment</a>
                    </div>

                    <div class="doctor-bottom">
                        <h3><a routerLink="/doctor-details">Dr. Sarah Tylor</a></h3>
                        <span>Dental Surgeon</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="doctor-btn">
            <a routerLink="/doctor">See All</a>
        </div>
    </div>
</section>

<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Our Latest Blogs</h2>
        </div>

        <div class="row">
            <div class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="blog-item">
                    <div class="blog-top">
                        <a>routerLink="/blog-details"><img src="assets/img/home-one/home-bg11.jpg" alt="Blog" /></a>
                    </div>

                    <div class="blog-bottom">
                        <h3>
                            <a routerLink="/blog-details">In this hospital there are special surgeons.</a>
                        </h3>
                        <p>
                            Lorem ipsum is dolor sit amet, csectetur adipiscing elit, dolore smod tempor incididunt ut
                            labore et....
                        </p>
                        <ul>
                            <li>
                                <a>routerLink="/blog-details">Read More <i class="icofont-long-arrow-right"></i></a>
                            </li>
                            <li><i class="icofont-calendar"></i> Jan 03, 2020</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                <div class="blog-item">
                    <div class="blog-top">
                        <a>routerLink="/blog-details"><img src="assets/img/home-one/home-bg12.jpg" alt="Blog" /></a>
                    </div>

                    <div class="blog-bottom">
                        <h3><a routerLink="/blog-details">World AIDS Day, designated on 1 December.</a></h3>
                        <p>
                            Lorem ipsum is dolor sit amet, csectetur adipiscing elit, dolore smod tempor incididunt ut
                            labore et....
                        </p>
                        <ul>
                            <li>
                                <a>routerLink="/blog-details">Read More <i class="icofont-long-arrow-right"></i></a>
                            </li>
                            <li><i class="icofont-calendar"></i> Jan 03, 2020</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div
                class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4 wow animate__animated animate__fadeInUp"
                data-wow-delay=".7s"
            >
                <div class="blog-item">
                    <div class="blog-top">
                        <a>routerLink="/blog-details"><img src="assets/img/home-one/home-bg13.jpg" alt="Blog" /></a>
                    </div>

                    <div class="blog-bottom">
                        <h3>
                            <a>routerLink="/blog-details">More than 80 clinical trials launch to test coronavirus.</a>
                        </h3>
                        <p>
                            Lorem ipsum is dolor sit amet, csectetur adipiscing elit, dolore smod tempor incididunt ut
                            labore et....
                        </p>
                        <ul>
                            <li>
                                <a>routerLink="/blog-details">Read More <i class="icofont-long-arrow-right"></i></a>
                            </li>
                            <li><i class="icofont-calendar"></i> Jan 03, 2020</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
